import {createContext, useContext, useState} from "react";
import {Container, Drawer, Grid, Typography} from "@mui/material";
import * as React from "react";
import {RREventContainer} from "./RREvents";
import {getDealEvents} from "../../deals/dealsApi";
import {useNotify} from "../../../domains/common/components/AlertNotify";
import {Title5} from "../../../domains/common/components/Typography";

export const EventsDealContext = createContext();

/**
 * События возникающие по сделке на стороне Росреестра
 * @param closeOnBackdrop
 * @return {(React.JSX.Element|(function(*): Promise<void>)|*|closeDrawer)[]}
 * @constructor
 */
export default function EventsDrawer({closeOnBackdrop}) {
  const [drawerState, setDrawerState] = useState(false);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);

  const getEvents = async (dealId) => {
    setLoader(true)
    const result = await getDealEvents(dealId);

    if (result.ok) {
      setData(result.data);
    } else {
      setData({});
    }
    setLoader(false);
  }

  const openEventsDrawer = async (dealId) => {
    setDrawerState(true);
    await getEvents(dealId);
  };

  const closeEventsDrawer = () => {
    setDrawerState(false);
  };

  return {
    eventsDrawerComponent: (
      <Drawer open={drawerState} anchor='right' ModalProps={{
        onBackdropClick: async () => {
          if (closeOnBackdrop)
            setDrawerState(false);
        }
      }}>
        <Container sx={{width: 600, padding: 1}}>
          {
            loader ? 'Идёт загрузка обновленных событий ...' :
              <>
                <AboutDeal values={data}/>
                <RREventsList rrEvents={data.rrEvents}/>
              </>
          }
        </Container>
      </Drawer>),
    openEventsDrawer,
    closeEventsDrawer
  }
}

const AboutDeal = ({values}) => {
  const {openNotify} = useNotify();

  const copyOnClick = (text) => {
    navigator.clipboard.writeText(text)

    openNotify({
      msg: "Скопировано",
      duration: 1200,
      type: 'success',
      positionH: 'right',
    })
  }

  return (
    <>
      <Grid container spacing={0} xs={12}>
        <Grid item xs={12} sx={{fontWeight: 'light', fontSize: 16}}>
          Сделка создана {values.dealCreated} (МСК)
        </Grid>
        {values.rrData?.kuvdNumber ?
          <><Grid item xs={12} sx={{height: '20px'}}/>
            <Grid item xs={12}>
              <Title5 title="Сведения Росреестра"/>
              <Grid item xs={12} sx={{height: '20px'}}/>
              {values.rrData?.kuvdNumber ?
                <Grid item xs={12} sx={{fontWeight: 'light', fontSize: 16}}>
                  <a onClick={() => copyOnClick(values.rrData?.kuvdNumber)} className="copyOnClickText">
                    {values.rrData?.kuvdNumber}
                  </a>
                </Grid> : void 0}
              {values.rrData?.rrData?.requestNumber ?
                <Grid item xs={12}
                      sx={{fontWeight: 'light', fontSize: 16}}>{values.rrData?.requestNumber}</Grid> : void 0}
              {values.rrData?.uin ?
                <Grid item xs={12} sx={{fontWeight: 'light', fontSize: 16}}>УИН: <a
                  onClick={() => copyOnClick(values.rrData?.uin)}
                  className="copyOnClickText">{values.rrData?.uin}</a></Grid> : void 0}
            </Grid></>
          : ''}
        <Grid item xs={12} sx={{height: '20px'}}/>
      </Grid>
    </>
  );
}

const RREventsList = ({rrEvents}) => {
  if (!rrEvents?.length)
    return <Typography sx={{fontWeight: 300}} variant="h6" gutterBottom display="inline">
      События Росреестра отсутствуют
    </Typography>

  return (
    <Grid container spacing={1} xs={12}>
      {
        rrEvents?.map((item) => {
          return <RREventContainer event={item}></RREventContainer>
        })
      }
    </Grid>
  )
}